'use client';

import Link from 'next/link';

const aboutLinks = [
  { name: 'About Us', href: '/about' },
  { name: 'Contact Us', href: '/contact' },
  { name: 'Our Blog', href: '/blog' },
  { name: 'Locations', href: '/locations' },
];

const orderLinks = [
  { name: 'Manage My Order', href: '/account' },
  { name: 'Track Order', href: '/track-order' },
  { name: 'Delivery Details', href: '/delivery' },
  { name: 'My Account', href: '/account' },
  { name: 'FAQs', href: '/faqs' },
];

const legalLinks = [
  { name: 'Cookie Policy', href: '/cookies' },
  { name: 'Privacy Policy', href: '/privacy' },
  { name: 'Terms & Conditions', href: '/terms' },
];

export default function Footer() {
  return (
    <footer className="footer">
      {/* Newsletter */}
      <div className="footer-newsletter">
        <div className="container footer-newsletter-inner">
          <div className="footer-newsletter-text">
            <h3>Get Bathroom Inspiration &amp; Exclusive Offers</h3>
            <p>Sign up for deals, new arrivals, and expert tips delivered to your inbox</p>
          </div>
          <form className="footer-newsletter-form" onSubmit={(e) => e.preventDefault()}>
            <input type="email" placeholder="Enter your email address" className="footer-newsletter-input" />
            <button type="submit" className="footer-newsletter-btn">Subscribe</button>
          </form>
        </div>
      </div>

      {/* Main Footer */}
      <div className="footer-main">
        <div className="container footer-grid">
          <div className="footer-col">
            <h4 className="footer-col-title">About Us</h4>
            <ul className="footer-links">
              {aboutLinks.map((l) => (
                <li key={l.name}><Link href={l.href} className="footer-link">{l.name}</Link></li>
              ))}
            </ul>
          </div>
          <div className="footer-col">
            <h4 className="footer-col-title">Help With Your Orders</h4>
            <ul className="footer-links">
              {orderLinks.map((l) => (
                <li key={l.name}><Link href={l.href} className="footer-link">{l.name}</Link></li>
              ))}
            </ul>
          </div>
          <div className="footer-col">
            <h4 className="footer-col-title">Legal / Policies</h4>
            <ul className="footer-links">
              {legalLinks.map((l) => (
                <li key={l.name}><Link href={l.href} className="footer-link">{l.name}</Link></li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Social + Payment — like Plumbworld bottom */}
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <div className="footer-social">
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="footer-social-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </a>
            <a href="https://www.instagram.com/bathroomfort/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="footer-social-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
            </a>
          </div>

          <div className="footer-payment">
            <span className="footer-payment-text">Visa</span>
            <span className="footer-payment-text">Mastercard</span>
            <span className="footer-payment-text">PayPal</span>
            <span className="footer-payment-text">Klarna</span>
            <span className="footer-payment-text">Apple Pay</span>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-copyright">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Bathroomfort. All rights reserved.</p>
        </div>
      </div>

      <style>{`
        .footer { margin-top: auto; }

        /* ===== NEWSLETTER ===== */
        .footer-newsletter {
          background: var(--color-accent);
          padding: 2rem 0;
        }
        .footer-newsletter-inner {
          display: flex;
          flex-direction: column;
          gap: 1.25rem;
          align-items: center;
          text-align: center;
        }
        .footer-newsletter-text h3 {
          font-size: 1.15rem;
          font-weight: 700;
          color: var(--color-primary-dark);
          margin-bottom: 0.2rem;
        }
        .footer-newsletter-text p {
          font-size: 0.85rem;
          color: var(--color-primary-dark);
          opacity: 0.75;
        }
        .footer-newsletter-form {
          display: flex;
          width: 100%;
          max-width: 440px;
        }
        .footer-newsletter-input {
          flex: 1;
          padding: 0.65rem 1rem;
          border: 2px solid var(--color-primary);
          border-right: none;
          border-radius: 0.5rem 0 0 0.5rem;
          font-size: 0.85rem;
          outline: none;
          background: var(--color-white);
        }
        .footer-newsletter-input:focus { border-color: var(--color-primary-dark); }
        .footer-newsletter-btn {
          padding: 0.65rem 1.5rem;
          background: var(--color-primary);
          color: var(--color-white);
          border: 2px solid var(--color-primary);
          border-radius: 0 0.5rem 0.5rem 0;
          font-size: 0.85rem;
          font-weight: 600;
          cursor: pointer;
          white-space: nowrap;
          transition: background 0.15s;
        }
        .footer-newsletter-btn:hover {
          background: var(--color-primary-dark);
          border-color: var(--color-primary-dark);
        }

        /* ===== MAIN FOOTER (4 columns) ===== */
        .footer-main {
          background: var(--color-primary);
          padding: 2.5rem 0 2rem;
        }
        .footer-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 1.75rem;
        }
        .footer-col-title {
          font-size: 0.85rem;
          font-weight: 700;
          color: var(--color-white);
          text-transform: uppercase;
          letter-spacing: 0.04em;
          margin-bottom: 0.75rem;
          padding-bottom: 0.5rem;
          border-bottom: 1px solid rgba(255,255,255,0.15);
        }
        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
        }
        .footer-link {
          font-size: 0.82rem;
          color: rgba(255,255,255,0.65);
          transition: color 0.15s;
        }
        .footer-link:hover { color: var(--color-accent); }

        /* ===== BOTTOM BAR ===== */
        .footer-bottom {
          background: var(--color-primary-dark);
          padding: 1.25rem 0;
        }
        .footer-bottom-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
        }
        .footer-social {
          display: flex;
          gap: 0.6rem;
        }
        .footer-social-link {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background: rgba(255,255,255,0.1);
          color: var(--color-white);
          transition: background 0.15s, color 0.15s;
        }
        .footer-social-link:hover {
          background: var(--color-accent);
          color: var(--color-primary-dark);
        }
        .footer-payment {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          flex-wrap: wrap;
          justify-content: center;
        }
        .footer-payment-icon {
          opacity: 0.5;
        }
        .footer-payment-text {
          font-size: 0.65rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          color: rgba(255,255,255,0.4);
          background: rgba(255,255,255,0.08);
          padding: 0.3rem 0.6rem;
          border-radius: 0.25rem;
        }

        /* ===== COPYRIGHT ===== */
        .footer-copyright {
          background: var(--color-primary-dark);
          border-top: 1px solid rgba(255,255,255,0.08);
          padding: 0.75rem 0;
          text-align: center;
        }
        .footer-copyright p {
          font-size: 0.7rem;
          color: rgba(255,255,255,0.35);
        }

        /* ===== RESPONSIVE ===== */
        @media (min-width: 640px) {
          .footer-newsletter-inner {
            flex-direction: row;
            text-align: left;
            justify-content: space-between;
          }
          .footer-grid {
            grid-template-columns: 1fr 1fr;
          }
          .footer-bottom-inner {
            flex-direction: row;
            justify-content: space-between;
          }
        }

        @media (min-width: 768px) {
          .footer-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }
      `}</style>
    </footer>
  );
}
